<template>
    <ul class="d-flex pagination">
        <li class="page-item"><span class="max-row-number">件数：{{getTotalRecord}}件</span></li>
        <li class="page-item">
            <a 
                class="page-link" 
                href="javascript:void(0);"
                @click="onClickFirstPage"
                :disabled="isInFirstPage">&lt;&lt;</a>
        </li>
        <li class="page-item">
            <a 
                @click="onClickPreviousPage"
                href="javascript:void(0);"
                :disabled="isInFirstPage" 
                class="page-link">&lt;</a>
        </li>
        <li class="page-item page-input-item">
            <input 
                type="number" 
                class="cell-input-field" 
                v-model="page"
                v-on:keyup.enter="onEnterPage"
                maxlength="2"><span class="total-page">/{{ getTotalPage }}</span>
        </li>
        <li class="page-item">
            <a 
            class="page-link"
            href="javascript:void(0);"
            @click="onClickNextPage"
            :disabled="isInLastPage">&gt;</a>
        </li>
        <li class="page-item">
            <a 
                class="page-link"
                href="javascript:void(0);"
                @click="onClickLastPage"
                :disabled="isInLastPage"
                >&gt;&gt;</a>
        </li>
    </ul>
  </template>
  <script>
  /* eslint-disable no-console */
  /* eslint-disable no-unused-vars */
  export default {
    name: "pagination",
    data: function () {
        return {
            page: 1,
        };
    },
    props: {
        maxRecord: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
    },
    watch:{
        currentPage: function(newVal, oldVal) {
            this.page = newVal
        }
    },
    computed: {
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
        getTotalPage() {
            return this.totalPages || 1
        },
        getTotalRecord() {
            return this.maxRecord || 0
        },
    },
    mounted: function () {
        console.log("pagination:mounted");
        this.page = this.currentPage
    },
    methods: {
        onClickFirstPage() {
            this.page = 1
            this.onPageChanged()
        },
        onClickPreviousPage() {
            this.page = this.currentPage - 1
            this.onPageChanged()
        },
        onEnterPage() {
            if (!this.page || this.page < 1 || this.page > this.totalPages) {
                this.page = this.currentPage
                return
            }
            this.onPageChanged()
        },
        onClickNextPage() {
            this.page = this.currentPage + 1
            this.onPageChanged()
        },
        onClickLastPage() {
            this.page = this.totalPages
            this.onPageChanged()
        },
        onPageChanged() {
            this.$emit('pagechanged', Number(this.page));    
        }
    }
  };
  </script>
  